import type { FieldValues } from 'features/libra/ontology/ontologyFieldTypes'
import { isSectionComplete } from 'features/libra/sections/SectionRegistry'
import type { LibraWorkflowGlobalContext } from 'features/libra/workflow/workflowStepsApi'

import type { ConditionalFormConfig } from './api/conditionalFormApi'
import { getVisibleSectionIds } from './conditionalFormSection/conditionalFormVisibility'

export function isConditionalFormStepComplete(params: {
  config: ConditionalFormConfig
  fieldValues: FieldValues
  globalContext: LibraWorkflowGlobalContext
}): boolean {
  const { config, fieldValues, globalContext } = params
  const visibleSectionIds = getVisibleSectionIds(config.form, fieldValues)

  return visibleSectionIds.every((sectionId) => {
    const section = config.sections.find(
      (candidate) => candidate.id === sectionId
    )
    return (
      !section ||
      isSectionComplete(section.type, section, fieldValues, globalContext)
    )
  })
}
